import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';

export type ModalType = 'NONE' | 'SUBSCRIPTION_REQUIRED' | 'OTHER_MODAL';

interface ModalState {
  showFSMModal: boolean;
  isFieldServePlus: boolean;
  hasNoFSMPlan: boolean;
}

const initialState: ModalState = {
  showFSMModal: false,
  isFieldServePlus: false,
  hasNoFSMPlan: false
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setShowFSMModal: (state, action: PayloadAction<boolean>) => {
      state.showFSMModal = action.payload;
    },
    setIsFieldServePlus: (state, action: PayloadAction<boolean>) => {
      state.isFieldServePlus = action.payload;
    },
    setHasNoFSMPlan: (state, action: PayloadAction<boolean>) => {
      state.hasNoFSMPlan = action.payload;
    }
  }
});

export const { setShowFSMModal, setIsFieldServePlus, setHasNoFSMPlan } = modalSlice.actions;

export const selectShowFSMModal = (state: RootState) => state.rootReducer.modal.showFSMModal;

export const selectIsFieldServePlus = (state: RootState) => state.rootReducer.modal.isFieldServePlus;

export const selectHasNoFSMPlan = (state: RootState) => state.rootReducer.modal.hasNoFSMPlan;

export default modalSlice.reducer;
